<template>
    <div class="Scheme">
        <layout>
            <template slot="content">
                <img src="@/assets/images/scheme/content1.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content2.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content3.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content4.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content5.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content6.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content7.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content8.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content9.jpg" class="contentImg"/>
                <img src="@/assets/images/scheme/content10.jpg" class="contentImg"/>
            </template>
        </layout>
    </div>
</template>

<script>
import Layout from '@/components/Layout/index.vue'
export default {
    name:'Scheme',
    components: {
        Layout
    },
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style scoped>
.contentImg{
    width: 100%;
    float: left;
}
</style>